import { View16, ViewOff16 } from '@carbon/icons-react';
import { useClickable } from '@chakra-ui/clickable';
import { Box, BoxProps } from '@chakra-ui/react';

export interface ToggleShowPasswordButtonProps extends BoxProps {
  passwordVisible?: boolean;
}

export const ToggleShowPasswordButton = ({
  passwordVisible,
  onClick,
  _focus,
  ...boxProps
}: ToggleShowPasswordButtonProps) => {
  return (
    <Box
      as="button"
      color="M.60"
      data-testid="toggle-pass-visibility"
      {...useClickable({ onClick })}
      _focus={{
        // TODO: Disable this after making designers agree with focus rings
        shadow: 'none',
        borderRadius: 'md',
        outline: 'none',
        ..._focus,
      }}
      {...boxProps}
    >
      {passwordVisible ? <ViewOff16 /> : <View16 />}
    </Box>
  );
};
